<template>
  <div class="px-3 mt-3">
    <v-card class="mx-auto pushdetail mb-1">
      <!-- NEW_DEV-1437 cyber start -->
      <!-- NEW_DEV-1783 cyber start -->
      <p class="detailhead">{{head_title}}{{push_date}}<br> <span v-if="this.shop_name">対象店舗：{{shop_name}}</span></p>
      <!-- NEW_DEV-1783 cyber end -->
      <Content :item="item" :contents_type="this.init.contents_type"></Content>
    </v-card>
  </div>
</template>

<script>
import Content from '@/views/notification/content.vue'
export default {
    data: () => ({
        item: null,
        create_date: '',
        push_date: '',
        shop_name: '',
        badgeParams: {},
        //NEW_DEV-1783 cyber start
        head_title: '',
        is_calendar: false,
        //NEW_DEV-1783 cyber end
    }),
    components: {
        Content
    },
    async created () {

      // GET パラメータを取得
      this.getUrlParam()

      //createdで、localstrageから全ての保存情報を取得しinitに格納
      this.init = this.storageGet('*')
      this.push_date = this.init.push_date;
      this.create_date = this.init.create_date;
      this.shop_name = this.init.shop_name;

      var params = { params:{
        'sid': this.init.sid,
        'service_cd': this.init.service_cd,
        'device_uid': this.init.device_uid,
        'device_id': this.init.device_id,
        'os': this.init.os,
        'key': this.init.key,
        'id': this.init.id,
        'preview': this.getUrlGetParam('preview'),
      }}

      try{
          var res = null;
          if (this.init.contents_type == 1 || this.init.contents_type == 2) {
              // イベントお知らせ
              res = await this.apiCall('/notices/detail1', params, 'get');
              if (!res) return false;
              this.$set(this, 'item', res);
              //NEW_DEV-1921 cyber start
              var _params = { params: {
                'sid': this.init.sid,
                'service_cd': this.init.service_cd,
                'device_uid': this.init.device_uid,
                'device_id': this.init.device_id,
                'os': this.init.os,
                'key': this.init.key,
                'id': this.getUrlGetParam('push_id') ? this.getUrlGetParam('push_id') : this.init.id,
                'preview': this.getUrlGetParam('preview'),
              }};
              res = await this.apiCall('/user/notification/detail', _params, 'get');
              if (!res) return false;
              if (this.getUrlGetParam('push_id') && res.data != null) {
                this.shop_name = res.data.shop_name;
              } else {
                this.shop_name = this.item.shop_name;
              }
              //NEW_DEV-1921 cyber end
              if (res.data != null) {
                this.push_date = res.data.push_date;
              } else if (_params.params.preview == 1) {
                var today = new Date();
                this.push_date = today.getFullYear() + '年' + (today.getMonth() + 1) + '月' + today.getDate() + '日';
              }
          } else if (this.init.contents_type == 30) {
              // スタンプメモ
              params = { params: {
                  'sid': this.init.sid,
                  'device_uid': this.init.device_uid,
                  'device_id': this.init.device_id,
                  'os': this.init.os,
                  'key': this.init.key,
                  'page': 1,
                  'stamp_id': this.$route.query.stamp_id,
                  'shop_id': this.$route.query.shop_id,
                  'id': this.$route.query.id,
              }}
              res = await this.apiCall('/stamp/memo-list', params, 'get')
              if (!res || !res.data) return false;
              this.$set(this, 'item', res.data[0]);
              this.push_date = this.item.memo_date;
              this.head_title = '';
              this.shop_name = this.item.shop;
          } else {
              // プッシュ通知詳細
              params = { params:{
                'sid': this.init.sid,
                'service_cd': this.init.service_cd,
                'device_uid': this.init.device_uid,
                'device_id': this.init.device_id,
                'os': this.init.os,
                'key': this.init.key,
                'id': params.id = this.getUrlGetParam('push_id') ? this.getUrlGetParam('push_id') : this.init.id,
                'preview': this.getUrlGetParam('preview'),
              }}

              res = await this.apiCall('/user/notification/detail', params, 'get');
              if (!res) return false;
              this.$set(this, 'item', res.data);
              //NEW_DEV-1783 cyber start
              this.head_title = '配信日時：';
              this.push_date = res.data.push_date;
              //NEW_DEV-1783 cyber end

              if (this.getUrlGetParam('push_id') && res.data != null) {
                this.shop_name = res.data.shop_name;
              } else {
                this.shop_name = this.item.shop_name;
              }
              // NEW_DEV-1437 cyber end
          }

          if (this.init.contents_type != 30) {
            this.badgeParams['_vue_param'] = true;
            this.badgeParams['menu_data'] = res.badges.menu_data;
            this.badgeParams['total_unread_count'] = res.badges.total_unread_count;
            this.nativePost(this.badgeParams);
          }
      } catch(e) {
          this.callDialog('通信エラー', 'ネットワークの状態が不安定です。再度お試しください', 3);
      }
    },
    //NEW_DEV-1783 cyber start
    beforeRouteEnter (to, from, next) {
      if(from.path == "/calendar"){
        next(vm => {
          vm._data.is_calendar = true
        });
      } else {
        next(vm => {
          vm._data.is_calendar = false
        });
      }
    },
    //NEW_DEV-1783 cyber end
  methods: {
    onClickBtn(link) {
      this.$router.push(link)
    }
  }
}
</script>

<style scoped>
/* vue css override */
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 10px;
  margin-bottom: 40px;
}
/* original css */
.pushdetail {
  background-color: #EEEEEE;
  padding-top: 10px;
}
.detailhead {
  text-align: center;
  font-size: 11px;
  margin: 0 0 10px;
}
.topbar {
  height: 15px;
  margin-bottom: 15px;
}
.vdbar {
  width: 94%;
  margin: 16px auto 0;
}
.push_title {
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  color: #333;
  text-align: center;
  display: block;
  padding: 10px 16px 5px;
}
.push_contents {
  padding: 16px;
}
.v-card >>> .push_contents img {
  max-width: 100%;
}
</style>
